import firebase from 'firebase/app';
import 'firebase/analytics';

  // Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  var firebaseConfig = {
    apiKey: "AIzaSyCn0TEbSpayZNcxKPu2XfUd89IC-_S4Few",
    authDomain: "pass-app-3c70a.firebaseapp.com",
    projectId: "pass-app-3c70a",
    storageBucket: "pass-app-3c70a.appspot.com",
    messagingSenderId: "955854072188",
    appId: "1:955854072188:web:35d56f80e9b39238021cf9",
    measurementId: "G-WHPJD6MVXE"
  };

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
 const ana =  firebase.analytics();

export { ana };